<template>
  <div>
    <common-header title="pricing"></common-header>
    <div class="pricing-wrapper">
      <pricing-card
        :row="data"
        v-for="(data, index) in pricingCard"
        :key="index"
      >
      </pricing-card>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import CommonHeader from "@/components/base/header";
import PricingCard from "@/components/pages/pricing/card.vue";

export default {
  data() {
    return {
      pricingCard: [
        {
          title: "Entry",
          rule: "1 user / month",
          cost: "Free",
          description: [
            "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod",
            "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod",
            "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod",
            "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod",
          ],
          button: "Start Using",
          theme: "default",
        },
        {
          title: "Marketer",
          rule: "1 user / month",
          cost: "US$ 5",
          description: [
            "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod",
            "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod",
            "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod",
            "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod",
          ],
          button: "Upgrade",
          theme: "blue",
        },
        {
          title: "Premium",
          rule: "1 user / month",
          cost: "US$ 10",
          description: [
            "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod",
            "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod",
            "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod",
            "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod",
          ],
          button: "Upgrade",
          theme: "green",
        },
      ],
    };
  },
  components: {
    CommonHeader,
    PricingCard,
  },
};
</script>
<style lang="sass" scoped>
.pricing
  &-wrapper
    margin-top: 20px
    display: flex
    justify-content: space-around
</style>
